import React from 'react';

import { FieldControl } from './FieldControl';
import { useFieldDecorator } from '../../context/FieldDraftContext';

type DraftAwareFieldControlProps = React.ComponentProps<typeof FieldControl>;

/**
 * `FieldControl` with the optional draft seam applied.
 *
 * With no decorator installed this is `FieldControl` plus one context read —
 * same props, same element, no wrapper node. That matters: every existing form
 * renders through this path, and an extra `<div>` would change layouts nobody
 * asked to change.
 */
export const DraftAwareFieldControl = (props: DraftAwareFieldControlProps) => {
  const decorate = useFieldDecorator();

  if (!decorate) {
    return <FieldControl {...props} />;
  }

  const decoration = decorate({
    fieldId: props.meta.id,
    value: props.value,
    onChange: props.onChange,
  });

  const control = (
    <FieldControl
      {...props}
      value={decoration.value}
      onChange={decoration.onChange}
    />
  );

  if (!decoration.wrap) {
    return control;
  }
  return <React.Fragment>{decoration.wrap(control)}</React.Fragment>;
};
